module.exports = __webpack_public_path__ + "prod/20260407195614/img/service.edbff227.png";